<template>
  <QuickContactBar></QuickContactBar>
  <NavBar></NavBar>
  <div class="container-xxl bg-white p-0">
  <router-view></router-view>
</div>
  <FooterBar></FooterBar>
</template>

<script>

import NavBar from './components/NavBar.vue'
import FooterBar from './components/FooterBar.vue'
import QuickContactBar from './components/QuickContactBar.vue'

export default {
  name: 'App',
  components: {
    NavBar, FooterBar, QuickContactBar
  },
  data() {
    return {
      
    }
  },
  computed: {
   
  },
  async mounted() {
    await this.loadScript('https://code.jquery.com/jquery-3.4.1.min.js');
    await this.loadScript('https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js');

    // Moment.js must come before Tempus Dominus
    await this.loadScript('/lib/tempusdominus/js/moment.min.js');
    await this.loadScript('/lib/tempusdominus/js/moment-timezone.min.js');

    // Then Tempus Dominus can be loaded
    await this.loadScript('/lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js');

    // Other libraries
    await this.loadScript('/lib/wow/wow.min.js');
    await this.loadScript('/lib/easing/easing.min.js');
    await this.loadScript('/lib/waypoints/waypoints.min.js');
    await this.loadScript('/lib/counterup/counterup.min.js');
    await this.loadScript('/lib/owlcarousel/owl.carousel.min.js');

    // Finally your custom main.js
    await this.loadScript('/js/main.js');
  },
  methods: {
    loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return resolve();

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      resolve();
    };
    script.onerror = (e) => {
      console.error(`Failed to load script: ${src}`, e);
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.body.appendChild(script);
  });
}

  }
}



</script>
<style>

@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/style.css";
</style>
